import React from 'react'

const ApplicantTableList = ({ displayName,displayValue}) => {
  return (
      <>
          <tr>
              <td className='thead'>
                  {displayName}
              </td>
              <td>
                  {displayValue}
              </td>
          </tr>
      </>
  )
}

export default ApplicantTableList